import css from './ComingSoon.module.css';

export function ComingSoon() {
  return (
    <div className={css.wrapper}>
      <div className={css.circle}>🎉</div>
      <h1 className={css.title}>Coming Soon!</h1>
      <p className={css.description}>
        This feature is currently under development. We’re hard at work putting
        the finishing touches on it and will roll it out as soon as possible.
      </p>
    </div>
  );
}
